import React from "react";
import { BellOutlined } from "@ant-design/icons";
import { Avatar, Badge, Dropdown, Menu } from "antd";
import { Registrations } from "assets/icons";
import { saveNotificationToLocalStorage } from "utils/auth/localStorage";
import useTranslation from "utils/hooks/useTranslation";
import * as S from "../layout/styled/topBar.styled";

interface INotification {
  hasNotification: boolean;
  notificationMessage: string[];
}
const Notification = ({ hasNotification, notificationMessage }: INotification) => {
  const NO_NOTIFICATIONS_MESSAGE = useTranslation({ id: "no_notifications" });
  const TITLE_NOTIFICATION = useTranslation({ id: "notifications" });
  const DESCRIPTION_NOTIFICATION_MESSAGE = useTranslation({ id: "click_here_to_update" });
  const hasNotificationUndefined = notificationMessage.includes(undefined);

  const notificationRead = () => {
    saveNotificationToLocalStorage(false);
    window.location.reload();
  };

  const menu =
    notificationMessage?.length >= 1 && !hasNotificationUndefined && hasNotification ? (
      <Menu>
        <Menu.ItemGroup title={TITLE_NOTIFICATION}>
          {notificationMessage?.map((notification, index) => (
            <div key={index}>
              <Menu.Item
                icon={<Registrations style={S.NotificationIcon} />}
                style={{
                  wordBreak: "break-all",
                }}
                data-testid="dropdown-menu"
                onClick={() => notificationRead()}
              >
                <S.NotificationBox>
                  <span style={{ fontSize: "15px" }}>{notification}</span>
                  <br></br>
                  <span style={{ fontSize: "12px" }}>{DESCRIPTION_NOTIFICATION_MESSAGE}</span>
                </S.NotificationBox>
              </Menu.Item>
            </div>
          ))}
        </Menu.ItemGroup>
      </Menu>
    ) : (
      <Menu>
        <Menu.Item>
          <span>{NO_NOTIFICATIONS_MESSAGE}</span>
        </Menu.Item>
      </Menu>
    );

  return (
    <Dropdown overlay={menu} placement="bottomLeft" className="notification">
      <Badge count={notificationMessage?.length >= 1 && !hasNotificationUndefined && hasNotification ? notificationMessage?.length : null}>
        <Avatar style={S.Avatar} size={40} className="avatarNotification" icon={<BellOutlined width="24" height="24" className="bellIcon" />} data-testid="notification" />
      </Badge>
    </Dropdown>
  );
};

export default Notification;
